// REPORT LIST
export const REPORT_LIST = "REPORT_LIST";
export const REPORT_LIST_SUCCESS = "REPORT_LIST_SUCCESS";
export const REPORT_LIST_FAIL = "REPORT_LIST_FAIL";
export const REPORT_LIST_RESET = "REPORT_LIST_RESET";
export const REPORT_LIST_COLUMN = "REPORT_LIST_COLUMN";

// REPORT EXPORT
export const REPORT_EXPORT = "REPORT_EXPORT";
export const REPORT_EXPORT_SUCCESS = "REPORT_EXPORT_SUCCESS";
export const REPORT_EXPORT_FAIL = "REPORT_EXPORT_FAIL";
export const REPORT_EXPORT_RESET = "REPORT_EXPORT_RESET";

// REPORT DOWNLOAD
export const REPORT_DOWNLOAD = "REPORT_DOWNLOAD";
export const REPORT_DOWNLOAD_SUCCESS = "REPORT_DOWNLOAD_SUCCESS";
export const REPORT_DOWNLOAD_FAIL = "REPORT_DOWNLOAD_FAIL";
export const REPORT_DOWNLOAD_RESET = "REPORT_DOWNLOAD_RESET";
